import { prop } from 'ramda';

import { compact } from '../../../../helpers/compact';
import { DocumentType } from '../../../../types/document';
import { toTextFromProp } from '../../fields/text';
import { relatedPushs } from '../../partials/related-push';
import { processSlices } from '../../slices';
import customSliceMapper from '../../slices/postmen';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicPostmen
 */

/**
 * @typedef {DocumentSchema} PostmenSchema
 */

const processCustomSlices = processSlices(customSliceMapper);

/**
 * Transform the given input into objects
 *
 * @param  {PrismicPostmen} data
 * @return {PostmenSchema}
 */
const processPostmen = (data) => {
  return compact({
    uid: DocumentType.POSTMEN,
    type: DocumentType.POSTMEN,
    title: toTextFromProp('title', data),
    chapeau: prop('chapeau', data),
    relatedPushs: relatedPushs(data),
    body: processCustomSlices(prop('slices', data)),
  });
};

/**
 * Normalizr schema representing a postmen page
 */
export const PostmenEntity = deprecatedPageEntity(DocumentType.POSTMEN, {
  processStrategy: (entity) => ({
    ...processPostmen(prop('data', entity)),
  }),
});
